import { render } from "./client-table.vue?vue&type=template&id=0be3071a"
import script from "./client-table.vue?vue&type=script&lang=js"
export * from "./client-table.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__